<template>
  <form @submit.prevent="submitForm">
    <div class="vx-row">
        <div class="vx-col mt-6 w-1/3">
          <vx-card title="Customer Info">
            <div class="centerx labelx">
              <vs-input
                required
                :danger="!!errors['first_name']"
                :danger-text="errors['first_name'] ? errors['first_name'][0] : null"
                val-icon-danger="error_outline"
                class="w-full"
                type="text"
                label="First Name"
                v-model="form.first_name"
              />
              <vs-input
                required
                :danger="!!errors['last_name']"
                :danger-text="errors['last_name'] ? errors['last_name'][0] : null"
                class="mt-3 w-full"
                val-icon-danger="error_outline"
                type="text"
                label="Last Name"
                v-model="form.last_name"
              />
              <vs-input
                required
                :danger="!!errors['email']"
                :danger-text="errors['email'] ? errors['email'][0] : null"
                class="mt-3 w-full"
                val-icon-danger="error_outline"
                type="email"
                label="Email"
                v-model="form.email"
              />
              <vs-input
                required
                class="mt-3 w-full"
                :danger="!!errors['phone']"
                :danger-text="errors['phone'] ? errors['phone'][0] : null"
                val-icon-danger="error_outline"
                type="phone"
                label="Phone"
                v-model="form.phone"/>
            </div>
          </vx-card>
        </div>
        <div class="vx-col mt-6 w-2/3">
          <vx-card title="Shipping Info">
            <div class="centerx labelx">
              <vs-input
                required
                :danger="!!errors['address.street1']"
                :danger-text="errors['address.street1'] ?errors['address.street1'][0] : null"
                val-icon-danger="error_outline"
                class="w-full"
                type="text"
                label="Street"
                v-model="form.address.street1"
              />
              <vs-input
                class="mt-3 w-full"
                :danger="!!errors['address.street2']"
                :danger-text="errors['address.street2'] ? errors['address.street2'][0] : null"
                val-icon-danger="error_outline"
                type="text"
                label="Street 2"
                v-model="form.address.street2"
              />
              <div class="vx-row">
                <vs-select
                  :danger="!!errors['address.country_code']"
                  :danger-text="errors['address.country_code'] ? errors['address.country_code'][0] : null"
                  placeholder="Select"
                  class="mt-3 vx-col"
                  label="Country"
                  v-model="form.address.country_code"
                >
                  <vs-select-item v-for="(country_code, index) in countries" :key="index" :value="country_code.code" :text="country_code.name" />
                </vs-select>
                <vs-select
                  :danger="!!errors['address.state_province']"
                  :danger-text="errors['address.state_province'] ? errors['address.state_province'][0] : null"
                  placeholder="Select"
                  class="mt-3 vx-col"
                  label="State/Province"
                  v-model="form.address.state_province"
                >
                  <vs-select-item v-for="(state_province, index) in statesProvinces" :key="index" :value="state_province.code" :text="state_province.name" />
                </vs-select>
              </div>
              <div class="vx-row">
                <vs-input
                  required
                  :danger="!!errors['address.city']"
                  :danger-text="errors['address.city'] ? errors['address.city'][0] : null"
                  val-icon-danger="error_outline"
                  class="mt-3 vx-col"
                  type="text"
                  label="City"
                  v-model="form.address.city"
                />
                <vs-input
                  required
                  :danger="!!errors['address.zip']"
                  :danger-text="errors['address.zip'] ? errors['address.zip'][0] : null"
                  val-icon-danger="error_outline"
                  class="mt-3 vx-col"
                  type="text"
                  label="Zip Code"
                  v-model="form.address.zip"
                />
              </div>
            </div>
          </vx-card>
        </div>
        <div class="vx-col mt-6 w-full">
          <vx-card title="Notes">
            <vs-input
              required
              label="User Id"
              type="text"
              :danger="!!errors['userId']"
              :danger-text="errors['userId'] ? errors['userId'][0] : null"
              val-icon-danger="error_outline"
              v-if="!userId"
              v-model="userIdInput"
            />
            <div v-else><b>User Id:</b> {{userId}}</div>
            <vs-select
              class="mt-5 vx-col w-1/2"
              label="Reason for Replacement"
              v-model="reason"
            >
              <vs-select-item v-for="(reason, index) in reasons" :key="index" :value="reason" :text="reason" is-selected.sync/>
            </vs-select>
          </vx-card>
        </div>
        <div class="vx-col mt-5 w-full">
          <vs-alert class="mb-4" :active="Object.keys(errors).length ? true : false" color="danger" icon="error_outline" >
            <span>There are errors, please fix them.</span>
          </vs-alert>
          <vs-alert class="mb-4" :active="serverError" color="danger" icon="error_outline" >
            <span>{{serverError}}</span>
          </vs-alert>
          <vs-button @click="confirmSubmit = true" v-if="!confirmSubmit">Replace Kit</vs-button>
          <div class="mb-5 font-semibold" v-if="confirmSubmit">Are you sure you want to replace kit ({{ kitId }})</div>
          <vs-row v-if="confirmSubmit">
              <vs-button button="submit" type="gradient" class="mr-2" :disabled="isLoading">Yes</vs-button>
              <vs-button color="danger" type="gradient" @click="confirmSubmit = false" :disabled="isLoading">No</vs-button>
          </vs-row>
        </div>

    </div>
  </form>
</template>

<script>
import dnaApi from "@/http/dnaApi";
import api from "@/http/api";
import types from '@/models';
import countryState from '@/helpers/countryStateHelper';

export default {
  props: [
    'next',
    'kitId',
    'userId',
    'isLoading',
    'replacementDetails'
  ],
  data() {
    return {
      purchaseHistory: null,
      dnaKit: null,
      form: new types.DNAKitReplacementForm({kitId: this.kitId}),
      errors: {},
      serverError: null,
      countries: countryState.getCountries(),
      statesProvinces: [],
      confirmSubmit: false,
      userIdInput: this.userId,
      reason: 'Sample Failed',
      reasons: [
        'Sample Failed',
        'Lost In Mail',
        'Sample Destroyed',
      ]
    }
  },
  mounted() {
   this.fetchPurchasedInfo();
   this.getStatesProvinces()
  },
  watch: {
    "form.address.country_code" (val, oldval) {
      this.getStatesProvinces();
      if(oldval !== "" && val !== oldval) this.form.address.state_province = "";
    }
  },
  methods: {
    async fetchPurchasedInfo() {
      this.$emit('update:isLoading', true);

      this.dnaKit = await dnaApi.getKitByKitId(this.kitId);
      this.purchaseHistory = await dnaApi.getPurchasedKits(this.kitId);
      this.setFormDefaults();

      this.$emit('update:isLoading', false);
    },
    getStatesProvinces() {
      this.statesProvinces = countryState.getStates(this.form.address.country_code);
    },
    setFormDefaults() {
      if(!this.purchaseHistory || !this.purchaseHistory.shipTo) return;
      const { shipTo } = this.purchaseHistory;
      const name = shipTo.name.split(" ");
      this.form = new types.DNAKitReplacementForm({
        kitId: this.kitId,
        first_name: name[0],
        last_name: name[1],
        email: shipTo.email,
        phone: shipTo.phone,
        street1: shipTo.street1,
        street2: shipTo.street2,
        city: shipTo.city,
        country_code: shipTo.country,
        zip: shipTo.postalCode,
        state_province: shipTo.state
      });
    },
    async submitForm() {
      this.$emit('update:isLoading', true);
      this.serverError = null;
      this.errors = {};

      const user = await api.fetchUser(this.userIdInput);
      if(!user) {
        this.confirmSubmit = false;
        this.errors = {userId: ["No user found!"]};
        this.$emit('update:isLoading', false);
        return;
      }

      const order = await dnaApi.createDnaOrder(this.form);

      if (order.serverError) {
        this.$emit('update:isLoading', false);
        this.confirmSubmit = false;
        return this.serverError = order.serverError;
      }

      if (order.errors) {
        this.$emit('update:isLoading', false);
        this.confirmSubmit = false;
        return this.errors = order.errors;
      }

      let resultMessages = [{ type: 'ok', result: 'A replacement kit order was created successfully.' }];
      const archiveResponse = await dnaApi.archiveKit(this.kitId, parseInt(this.userIdInput));
      const userNoteResponse = await api.addUserNote(this.userIdInput, { message: `Replaced DNA Kit (${this.kitId}) because ${this.reason}`, eventType: "Kit Replacement" });

      if (archiveResponse) resultMessages = resultMessages.concat(archiveResponse);

      resultMessages.push({
        type: userNoteResponse ? 'ok' : 'error',
        result: `Note added to userId: ${this.userIdInput} ${userNoteResponse ? 'successfully' : 'unsuccessfully'}.`
      });

      this.$emit('update:replacementDetails', {...order, resultMessages: resultMessages});
      this.resetForm();
      this.next();
    },
    resetForm() {
      this.purchaseHistory = null;
      this.dnaKit = null;
      this.form = new types.DNAKitReplacementForm();
      this.errors = {};
      this.countries = countryState.getCountries();
      this.statesProvinces = [];
      this.confirmSubmit = false;
      this.$emit('update:kitId', null);
      this.$emit('update:isLoading', false);
    }
  }
}
</script>
